import { render, staticRenderFns } from "./ManterPeticaoEditar.vue?vue&type=template&id=3dc2f358&scoped=true&"
import script from "./ManterPeticaoEditar.vue?vue&type=script&lang=js&"
export * from "./ManterPeticaoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2f358",
  null
  
)

export default component.exports